import { apiService } from './apiService';

export interface IStyle {
  _id: string;
  name: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export const styleApi = {
  // Get all styles
  getStyles: async (): Promise<IStyle[]> => {
    try {
      const response = await apiService.get('/styles');
      return response.data?.styles || [];
    } catch (error: any) {
      console.error('Error fetching styles:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch styles');
    }
  },

  // Get style by ID
  getStyleById: async (styleId: string): Promise<IStyle> => {
    try {
      const response = await apiService.get(`/styles/${styleId}`);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching style:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch style');
    }
  }
};
